import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  Type,
  viewChild,
} from '@angular/core';
import { GridColumn } from '@grid/abstractions';
import { GridTemplateCell } from '@shared/modules/grid/abstractions/grid-template-cell';
import { ContainerDirective } from '@shared/directives/container.directive';
import { GridRow } from '@shared/models/grid/grid-row';

@Component({
  standalone: false,
  selector: 'gstar-grid-template-factory',
  templateUrl: './grid-template-factory.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridTemplateFactoryComponent<T> implements AfterViewInit {
  header: InputSignal<GridColumn> = input.required();
  row: InputSignal<GridRow<T>> = input.required();
  container = viewChild<ContainerDirective>(ContainerDirective);

  ngAfterViewInit(): void {
    const container = this.container()!.viewContainerRef;
    container.clear();
    if (this.header().templateCell) {
      const gridTemplate = this.header().templateCell as Type<
        GridTemplateCell<T>
      >;
      const component = container.createComponent(gridTemplate);
      component.instance.row.set(this.row().data);
      component.instance.header.set(this.header());
      component.changeDetectorRef.markForCheck();
    }
  }
}
